import React from 'react';
import { Grid, Paper } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialBox from '../../../../components/MaterialBox';


const TaskStatusGrid = ({ employeeData }) => {

    const summary = employeeData?.overall_task_status || {};

    const completed = summary?.completed;
    const inProgress = summary?.in_progress;
    const hold = summary?.hold;
    const notStarted = summary?.not_started;
    const aborted = summary?.abort;

    const totalTask = summary?.total_task;

    const statusItems = [
        { label: 'Total Task', value: totalTask, background: 'linear-gradient(to right, #bfd0e3, #e4e6f2)' },
        { label: 'Completed', value: completed, background: 'linear-gradient(to right, #bfd0e3, #dcfce7)' },
        { label: 'In Progress', value: inProgress, background: 'linear-gradient(to right, #bfd0e3, #dbeafe)' },
        { label: 'Hold', value: hold, background: 'linear-gradient(to right, #bfd0e3, #fef9c3)' },
        { label: 'Aborted', value: aborted, background: 'linear-gradient(to right, #bfd0e3, #fee2e2)' },
        { label: 'Not Started', value: notStarted, background: 'linear-gradient(to right, #bfd0e3, #f3f4f6)' },
    ];

    return (
        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center' }}>
                <MaterialBox sx={{ width: '6px', height: '14px', backgroundColor: '#7783c9', borderRadius: 1 }} />
                <MaterialTypography variant="h6" fontWeight="bold" sx={{ fontSize: '1rem' }}>
                    Overall Task Status
                </MaterialTypography>
            </MaterialBox>
            <Grid container spacing={0.5}>
                {statusItems.map((item, index) => (
                    <Grid size={{ xs: 12, sm: 4, md: 4 }} key={index}>
                        <Paper
                            elevation={0}
                            sx={{
                                padding: 1,
                                textAlign: 'center',
                                background: item.background,
                                borderRadius: 2,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <MaterialTypography variant="h6" fontWeight="bold" sx={{ fontSize: '1rem' }}>
                                {item.value}
                            </MaterialTypography>
                            <MaterialTypography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', lineHeight: 1 }}>
                                {item.label}
                            </MaterialTypography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </MaterialBox>
    );
};

export default TaskStatusGrid;
